import {
    VEHICLE_ADS_FETCH,
    VEHICLE_ADS_DETAILS_CLEAR,
    VEHICLE_ADS_DETAILS_FETCH,
    VEHICLE_ADS_ADD_TO_FAVOURITE,
    VEHICLE_ADS_REMOVE_FROM_FAVOURITE,
    VEHICLE_ADS_REPORT,
    DASHBOARD_VEHICLE_REMOVE,
    VEHICLE_ADS_LIST_CLEAR
} from './constants';
import {
    getVehiclesList,
    getVehicleDetails,
    addVehicleToFavourites,
    removeVehicleFromFavourites,
    reportVehicleAd,
    createVehicleAd,
    deleteVehicle
} from '../services/vehicle'

export const startFetchVehicleAds = (filters={}) => {
    return (dispatch, getState) => {
        const vehicleFilters = {...getState().vehicleFilters, ...filters};
        return getVehiclesList({
            header: {
                Authorization: `Token ${getState().auth.token}`
            },
            parameter: Object.keys(vehicleFilters).filter(key => !!vehicleFilters[key]).reduce((acc, cur) => ({...acc, [cur]:vehicleFilters[cur]}), {})
        })
        .then((response) => {
            dispatch(fetchVehicleAds(response.data))
            return {
                success: {
                    status: response.status,
                    body: response.data
                }
            }
        })
        .catch((error) => {
            return {
                error: {
                    status: error.response.status,
                    body: error.response.data
                }
            }
        })
    }
};

const fetchVehicleAds = (payload) => ({
    type: VEHICLE_ADS_FETCH,
    payload
});

export const clearVehicleDetails = () => ({
    type: VEHICLE_ADS_DETAILS_CLEAR,
    payload: {}
})

export const clearVehicleList = () => ({
    type: VEHICLE_ADS_LIST_CLEAR,
    payload: {}
})

export const startFetchVehicleDetails = (advertiseId) => {
    return (dispatch, getState) => {
        return getVehicleDetails(advertiseId)
        .then((response) => {
            dispatch(fetchVehicleDetails(response.data))
            return {
                success: {
                    status: response.status,
                    body: response.data
                }
            }
        })
        .catch((error) => {
            return {
                error: {
                    status: error.response.status,
                    body: error.response.data
                }
            }
        })
    }
};

const fetchVehicleDetails = (payload) => ({
    type: VEHICLE_ADS_DETAILS_FETCH,
    payload
});

export const startAddVehicleToFavourites = (id=0) => {
    return (dispatch, getState) => {
        return addVehicleToFavourites({
            header: {
                Authorization: `Token ${getState().auth.token}`
            },
            body: {
                vehicleAd: id
            }
        })
        .then((response) => {
            dispatch(markVehicle({id:[id]}))
            return {
                success: {
                    status: response.status,
                    body: response.data
                }
            }
        })
        .catch((error) => {
            return {
                error: {
                    status: error.response.status,
                    body: error.response.data
                }
            }
        })
    }
};

const markVehicle = (payload) => ({
    type: VEHICLE_ADS_ADD_TO_FAVOURITE,
    payload
});

export const startRemoveVehicleFromFavourites = (id=0) => {
    return (dispatch, getState) => {
        return removeVehicleFromFavourites({
            header: {
                Authorization: `Token ${getState().auth.token}`
            }
        }, id)
        .then((response) => {
            dispatch(unMarkVehicle({id:[id]}))
            return {
                success: {
                    status: response.status,
                    body: response.data
                }
            }
        })
        .catch((error) => {
            return {
                error: {
                    status: error.response.status,
                    body: error.response.data
                }
            }
        })
    }
};

const unMarkVehicle = (payload) => ({
    type: VEHICLE_ADS_REMOVE_FROM_FAVOURITE,
    payload
});

export const startReportVehicleAd = (id=0) => {
    return (dispatch, getState) => {
        return reportVehicleAd({
            header: {
                Authorization: `Token ${getState().auth.token}`
            },
            body: {
                targetVehicleAd: id
            }
        })
        .then((response) => {
            return {
                success: {
                    status: response.status,
                    body: response.data
                }
            }
        })
        .catch((error) => {
            return {
                error: {
                    status: error.response.status,
                    body: error.response.data
                }
            }
        })
    }
};

export const startCreateVehicleAd = (body) => {
    return (dispatch, getState) => {
        return createVehicleAd({
            header: {
                Authorization: `Token ${getState().auth.token}`
            },
            body
        })
        .then((response) => {
            return {
                success: {
                    status: response.status,
                    body: response.data
                }
            }
        })
        .catch((error) => {
            return {
                error: {
                    status: error.response.status,
                    body: error.response.data
                }
            }
        })
    }
};

export const startDeleteVehicle = (id=0) => {
    return (dispatch, getState) => {
        return deleteVehicle({
            header: {
                Authorization: `Token ${getState().auth.token}`
            }
        }, id)
        .then((response) => {
            dispatch(deleteVehicleAction({id}))
            return {
                success: {
                    status: response.status,
                    body: response.data
                }
            }
        })
        .catch((error) => {
            return {
                error: {
                    status: error.response.status,
                    body: error.response.data
                }
            }
        })
    }
};

const deleteVehicleAction = (payload) => ({
    type: DASHBOARD_VEHICLE_REMOVE,
    payload
});